let initialState = {
  isSidebarExpanded: false,
  language: null,
  version: require('../../../package.json').version
}

export default {
  state: () => initialState,
  mutations: {
    TOGGLE_SIDEBAR(state) {
      state.isSidebarExpanded = !state.isSidebarExpanded
    },
    SET_LANGUAGE(state, language) {
      state.language = language
    },
    RESET(state) {
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  actions: {
    /**/
  },
  getters: {
    isSidebarExpanded: state => {
      return state.isSidebarExpanded
    },
    language: state => {
      return state.language
    },
    appVersion: state => {
      return state.version
    }
  }
}
